// import React, { useState, useEffect, useContext } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { ArrowLeft, Calendar, User, Clock, Edit, History } from 'lucide-react';
// import AuthContext from '../../../../../context/AuthContext';
// import { useToast } from '../../../../../context/ToastContext';
// import detailedHistoryService from '../../../../../services/detailedHistory';

// export default function ActivityDetailedLog() {
//   const { activityId } = useParams();
//   const navigate = useNavigate();
//   const { authTokens } = useContext(AuthContext);
//   const { showError } = useToast();
  
//   const [history, setHistory] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     fetchActivityEvolution();
//   }, [activityId]);

//   const fetchActivityEvolution = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const result = await detailedHistoryService.getActivityEvolutionHistory(activityId, authTokens.access);
//       if (result.success) {
//         setHistory(result.data);
//       } else {
//         setError(result.error);
//         showError(result.error || 'Erreur lors du chargement de l\'évolution de l\'activité');
//       }
//     } catch (err) {
//       setError('Erreur de connexion');
//       showError('Erreur de connexion');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const renderValue = (value) => {
//     if (value === null || value === undefined) {
//       return 'null';
//     }
//     if (typeof value === 'object') {
//       if (Array.isArray(value)) {
//         return `[${value.map(item => renderValue(item)).join(', ')}]`;
//       }
//       // Handle objects by showing key properties
//       if (value.risk_name) return value.risk_name;
//       if (value.activity_name) return value.activity_name;
//       if (value.process_name) return value.process_name;
//       if (value.action) return `Action: ${value.action}`;
//       if (value.email) return value.email;
//       if (value.name) return value.name;
//       return JSON.stringify(value);
//     }
//     return String(value);
//   };

//   const renderChanges = (changes) => {
//     if (!changes || Object.keys(changes).length === 0) {
//       return <p className="text-sm text-gray-500">Aucun changement détaillé enregistré.</p>;
//     }

//     return (
//       <ul className="space-y-2">
//         {Object.entries(changes).map(([field, values]) => (
//           <li key={field} className="text-sm">
//             <strong className="font-semibold text-gray-800">{field}:</strong>
//             <span className="ml-2">
//               <span className="text-red-600">'{renderValue(values.from)}'</span> 
//               <span className="mx-2">→</span> 
//               <span className="text-green-600">'{renderValue(values.to)}'</span>
//             </span>
//           </li>
//         ))}
//       </ul>
//     );
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-gray-50 p-6">
//       <div className="max-w-6xl mx-auto">
//         <button
//           onClick={() => navigate(-1)}
//           className="flex items-center text-gray-600 hover:text-gray-900 mb-6"
//         >
//           <ArrowLeft className="h-5 w-5 mr-2" />
//           Retour
//         </button>

//         <div className="bg-white rounded-lg shadow p-6">
//           <div className="flex items-center justify-between mb-6">
//             <h1 className="text-2xl font-bold text-gray-900">Évolution Complète de l'Activité</h1>
//             <div className="flex items-center text-gray-500">
//               <History className="h-5 w-5 mr-2" />
//               <span>{history.length} entrées d'historique</span>
//             </div>
//           </div>

//           {error && (
//             <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
//               <p className="text-red-800">{error}</p>
//               <button 
//                 onClick={fetchActivityEvolution}
//                 className="mt-2 text-red-600 hover:text-red-800 underline"
//               >
//                 Réessayer
//               </button>
//             </div>
//           )}

//           {history.length === 0 && !loading && (
//             <div className="text-center py-12">
//               <History className="h-16 w-16 text-gray-400 mx-auto mb-4" />
//               <p className="text-lg font-medium text-gray-900">Aucun historique trouvé</p>
//               <p className="text-gray-500">Cette activité n'a pas encore d'historique d'évolution.</p>
//             </div>
//           )}

//           <div className="space-y-6">
//             {history.map((entry, index) => (
//               <div key={entry.id} className="border border-gray-200 rounded-lg p-6 relative">
//                 {/* Timeline connector */}
//                 {index < history.length - 1 && (
//                   <div className="absolute left-6 top-16 w-0.5 h-6 bg-gray-300"></div>
//                 )}
                
//                 <div className="flex items-start space-x-4">
//                   <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
//                     entry.action_type === 'create' ? 'bg-green-100 text-green-600' :
//                     entry.action_type === 'update' ? 'bg-blue-100 text-blue-600' :
//                     entry.action_type === 'delete' ? 'bg-red-100 text-red-600' :
//                     'bg-gray-100 text-gray-600'
//                   }`}>
//                     <Edit className="h-4 w-4" />
//                   </div>
                  
//                   <div className="flex-1 min-w-0">
//                     <div className="flex items-center justify-between mb-2">
//                       <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
//                         entry.action_type === 'create' ? 'bg-green-100 text-green-800' :
//                         entry.action_type === 'update' ? 'bg-blue-100 text-blue-800' :
//                         entry.action_type === 'delete' ? 'bg-red-100 text-red-800' :
//                         'bg-gray-100 text-gray-800'
//                       }`}>
//                         {entry.action_type === 'create' ? 'Création' :
//                          entry.action_type === 'update' ? 'Modification' :
//                          entry.action_type === 'delete' ? 'Suppression' :
//                          entry.action_type}
//                       </span>
                      
//                       <div className="flex items-center text-sm text-gray-500 space-x-4">
//                         <div className="flex items-center">
//                           <User className="h-4 w-4 mr-1" />
//                           <span>{entry.done_by_email}</span>
//                         </div>
//                         <div className="flex items-center">
//                           <Calendar className="h-4 w-4 mr-1" />
//                           <span>{new Date(entry.action_date).toLocaleDateString('fr-FR')}</span>
//                         </div>
//                         <div className="flex items-center">
//                           <Clock className="h-4 w-4 mr-1" />
//                           <span>{new Date(entry.action_date).toLocaleTimeString('fr-FR')}</span>
//                         </div>
//                       </div>
//                     </div>
                    
//                     <div className="mb-3">
//                       <p className="text-gray-700 font-medium">{entry.description}</p>
//                     </div>
                    
//                     {entry.changes_summary && (
//                       <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
//                         <h4 className="text-sm font-semibold text-gray-800 mb-2">Changements détaillés:</h4>
//                         {renderChanges(entry.changes_summary)}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }





import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Calendar, User, Clock, Edit, History, Shield } from 'lucide-react';
import AuthContext from '../../../../../context/AuthContext';
import { useToast } from '../../../../../context/ToastContext';
import detailedHistoryService from '../../../../../services/detailedHistory';
import Pagination from '../../../../../components/Pagination';

export default function ActivityDetailedLog() {
  const { activityId } = useParams();
  const navigate = useNavigate();
  const { authTokens } = useContext(AuthContext);
  const { showError } = useToast();
  
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [pagination, setPagination] = useState({
    count: 0,
    page: 1,
    page_size: 10,
    total_pages: 0
  });

  useEffect(() => {
    fetchActivityEvolution();
  }, [activityId, pagination.page, pagination.page_size]);

  const fetchActivityEvolution = async () => {
    setLoading(true);
    setError(null);
    try {
      const pagination_data = {
        page: pagination.page,
        page_size: pagination.page_size,
      };
      
      const result = await detailedHistoryService.getActivityEvolutionHistory(activityId, authTokens.access, pagination_data);
      if (result.success) {
        setHistory(result.data.results || result.data);
        
        if (result.data.count !== undefined) {
          setPagination(prev => ({
            ...prev,
            count: result.data.count,
            total_pages: result.data.total_pages
          }));
        }
      } else {
        setError(result.error);
        showError(result.error || 'Erreur lors du chargement de l\'évolution de l\'activité');
      }
    } catch (err) {
      setError('Erreur de connexion');
      showError('Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, page: newPage }));
  };

  const handlePageSizeChange = (newPageSize) => {
    setPagination(prev => ({ 
      ...prev, 
      page_size: newPageSize, 
      page: 1 
    }));
  };

  const getHistoryTypeLabel = (historyType) => {
    switch(historyType) {
      case 'activity':
        return 'Activité';
      case 'activity_risk':
        return 'Risque d\'Activité';
      default:
        return historyType;
    }
  };

  const renderValue = (value) => {
    if (value === null || value === undefined) {
      return 'aucune valeur';
    }
    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        return `[${value.map(item => renderValue(item)).join(', ')}]`;
      }
      if (value.risk_name) return value.risk_name;
      if (value.activity_name) return value.activity_name;
      if (value.process_name) return value.process_name;
      if (value.action) return `Action: ${value.action}`;
      if (value.email) return value.email;
      if (value.name) return value.name;
      return JSON.stringify(value);
    }
    return String(value);
  };

  const renderChanges = (changesSummary) => {
    if (!changesSummary || Object.keys(changesSummary).length === 0) {
      return <p className="text-sm text-gray-500">Aucun changement détaillé enregistré.</p>;
    }

    const changes = [];

    // Handle actions (created, updated, deleted)
    if (changesSummary.actions) {
      const actions = changesSummary.actions;
      
      // Created actions
      if (actions.created && actions.created.length > 0) {
        actions.created.forEach((action, idx) => {
          changes.push(
            <li key={`created-${idx}`} className="text-sm">
              <strong className="font-semibold text-gray-800">Action créée:</strong>
              <div className="ml-4 mt-1 bg-green-50 p-2 rounded border border-green-200">
                <p className="text-green-800">
                  <strong>Description:</strong> {action.new?.action || 'N/A'}
                </p>
                {action.new?.dueDate && (
                  <p className="text-green-800">
                    <strong>Date d'échéance:</strong> {new Date(action.new.dueDate).toLocaleDateString('fr-FR')}
                  </p>
                )}
              </div>
            </li>
          );
        });
      }

      // Updated actions
      if (actions.updated && actions.updated.length > 0) {
        actions.updated.forEach((action, idx) => {
          if (action.changes && Object.keys(action.changes).length > 0) {
            changes.push(
              <li key={`updated-${idx}`} className="text-sm">
                <strong className="font-semibold text-gray-800">Action modifiée (ID: {action.id}):</strong>
                <ul className="ml-4 mt-1 space-y-1">
                  {Object.entries(action.changes).map(([field, values]) => (
                    <li key={field} className="text-sm">
                      <strong className="text-gray-700">{field}:</strong>
                      <span className="ml-2">
                        <span className="text-red-600">'{renderValue(values.old)}'</span>
                        <span className="mx-2">→</span>
                        <span className="text-green-600">'{renderValue(values.new)}'</span>
                      </span>
                    </li>
                  ))}
                </ul>
              </li>
            );
          }
        });
      }

      // Deleted actions
      if (actions.deleted && actions.deleted.length > 0) {
        actions.deleted.forEach((action, idx) => {
          changes.push(
            <li key={`deleted-${idx}`} className="text-sm">
              <strong className="font-semibold text-gray-800">Action supprimée:</strong>
              <div className="ml-4 mt-1 bg-red-50 p-2 rounded border border-red-200">
                <p className="text-red-800">
                  <strong>Description:</strong> {action.old?.action || 'N/A'}
                </p>
                {action.old?.dueDate && (
                  <p className="text-red-800">
                    <strong>Date d'échéance:</strong> {new Date(action.old.dueDate).toLocaleDateString('fr-FR')}
                  </p>
                )}
              </div>
            </li>
          );
        });
      }
    }

    // Handle consequence changes
    if (changesSummary.consequence) {
      const { old, new: newVal } = changesSummary.consequence;
      changes.push(
        <li key="consequence" className="text-sm">
          <strong className="font-semibold text-gray-800">Conséquence:</strong>
          <span className="ml-2">
            <span className="text-red-600">'{renderValue(old)}'</span>
            <span className="mx-2">→</span>
            <span className="text-green-600">'{renderValue(newVal)}'</span>
          </span>
        </li>
      );
    }

    // Handle probability changes
    if (changesSummary.probability) {
      const { old, new: newVal } = changesSummary.probability;
      changes.push(
        <li key="probability" className="text-sm">
          <strong className="font-semibold text-gray-800">Probabilité:</strong>
          <span className="ml-2">
            <span className="text-red-600">'{renderValue(old)}'</span>
            <span className="mx-2">→</span>
            <span className="text-green-600">'{renderValue(newVal)}'</span>
          </span>
        </li>
      );
    }

    // Handle any other direct field changes (for activity history type)
    Object.entries(changesSummary).forEach(([field, values]) => {
      // Skip already handled fields
      if (field === 'actions' || field === 'consequence' || field === 'probability') {
        return;
      }
      
      // Check if it has old/new or from/to structure
      if (values && typeof values === 'object') {
        const oldVal = values.old ?? values.from;
        const newVal = values.new ?? values.to;
        
        if (oldVal !== undefined || newVal !== undefined) {
          changes.push(
            <li key={field} className="text-sm">
              <strong className="font-semibold text-gray-800">{field}:</strong>
              <span className="ml-2">
                <span className="text-red-600">'{renderValue(oldVal)}'</span>
                <span className="mx-2">→</span>
                <span className="text-green-600">'{renderValue(newVal)}'</span>
              </span>
            </li>
          );
        }
      }
    });

    if (changes.length === 0) {
      return <p className="text-sm text-gray-500">Aucun changement détaillé enregistré.</p>;
    }

    return <ul className="space-y-2">{changes}</ul>;
  };

  if (loading && pagination.page === 1) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600"></div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 p-6">
      <div className="max-w-6xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-6"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          Retour
        </button>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-bold text-gray-900">Évolution Complète de l'Activité</h1>
            <div className="flex items-center text-gray-500">
              <History className="h-5 w-5 mr-2" />
              <span>{pagination.count} entrées d'historique</span>
            </div>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
              <p className="text-red-800">{error}</p>
              <button 
                onClick={fetchActivityEvolution}
                className="mt-2 text-red-600 hover:text-red-800 underline"
              >
                Réessayer
              </button>
            </div>
          )}

          {history.length === 0 && !loading && (
            <div className="text-center py-12">
              <History className="h-16 w-16 text-gray-400 mx-auto mb-4" />
              <p className="text-lg font-medium text-gray-900">Aucun historique trouvé</p>
              <p className="text-gray-500">Cette activité n'a pas encore d'historique d'évolution.</p>
            </div>
          )}

          <div className="space-y-6">
            {history.map((entry, index) => (
              <div key={`${entry.history_type}-${entry.id}`} className="border border-gray-200 rounded-lg p-6 relative">
                {index < history.length - 1 && (
                  <div className="absolute left-6 top-16 w-0.5 h-6 bg-gray-300"></div>
                )}
                
                <div className="flex items-start space-x-4">
                  <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
                    entry.action_type === 'create' ? 'bg-green-100 text-green-600' :
                    entry.action_type === 'update' ? 'bg-blue-100 text-blue-600' :
                    entry.action_type === 'delete' ? 'bg-red-100 text-red-600' :
                    'bg-gray-100 text-gray-600'
                  }`}>
                    {entry.history_type === 'activity_risk' ? <Shield className="h-4 w-4" /> : <Edit className="h-4 w-4" />}
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
                      <div className="flex items-center space-x-2">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          entry.action_type === 'create' ? 'bg-green-100 text-green-800' :
                          entry.action_type === 'update' ? 'bg-blue-100 text-blue-800' :
                          entry.action_type === 'delete' ? 'bg-red-100 text-red-800' :
                          'bg-gray-100 text-gray-800'
                        }`}>
                          {entry.action_type === 'create' ? 'Création' :
                           entry.action_type === 'update' ? 'Modification' :
                           entry.action_type === 'delete' ? 'Suppression' :
                           entry.action_type}
                        </span>
                        
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          entry.history_type === 'activity' ? 'bg-purple-100 text-purple-800' : 'bg-orange-100 text-orange-800'
                        }`}>
                          {entry.history_type === 'activity_risk' && <Shield className="h-3 w-3 mr-1" />}
                          {getHistoryTypeLabel(entry.history_type)}
                        </span>
                      </div>
                      
                      <div className="flex items-center text-sm text-gray-500 space-x-4">
                        <div className="flex items-center">
                          <User className="h-4 w-4 mr-1" />
                          <span>{entry.done_by_email}</span>
                        </div>
                        <div className="flex items-center">
                          <Calendar className="h-4 w-4 mr-1" />
                          <span>{new Date(entry.action_date).toLocaleDateString('fr-FR')}</span>
                        </div>
                        <div className="flex items-center">
                          <Clock className="h-4 w-4 mr-1" />
                          <span>{new Date(entry.action_date).toLocaleTimeString('fr-FR')}</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="mb-3">
                      <p className="text-gray-700 font-medium">{entry.description}</p>
                      {entry.history_type === 'activity_risk' && entry.risk_name && (
                        <p className="text-sm text-gray-600 mt-1">
                          <strong>Risque:</strong> {entry.risk_name}
                        </p>
                      )}
                    </div>
                    
                    {entry.changes_summary && (
                      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                        <h4 className="text-sm font-semibold text-gray-800 mb-2">Changements détaillés:</h4>
                        {renderChanges(entry.changes_summary)}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {history.length > 0 && (
            <div className="mt-6">
              <Pagination
                currentPage={pagination.page}
                totalPages={pagination.total_pages}
                totalItems={pagination.count}
                pageSize={pagination.page_size}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                loading={loading}
                itemName="entrées"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}